var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-primary d-flex justify-content-between mx-1"},[_c('div',[_vm._v(_vm._s(_vm.label)+":")]),_c('div',[_vm._v("R$ "+_vm._s(_vm._f("currency")(_vm.valor)))])])}
var staticRenderFns = []

export { render, staticRenderFns }